export function getCharacterSheetPath(character) {
  if (character?.sheetThreadSlug) {
    return `/threads/${character.sheetThreadSlug}`;
  }
  return null;
}

export function getCharacterProfilePath(characterOrId) {
  const id = typeof characterOrId === 'object' ? characterOrId?.id : characterOrId;
  if (!id) return null;
  if (typeof characterOrId === 'object' && characterOrId?.entityType === 'npc') {
    return null;
  }
  return `/characters/${id}`;
}

export function getCharacterThemePath(characterOrId) {
  const id = typeof characterOrId === 'object' ? characterOrId?.id : characterOrId;
  if (!id) return null;
  if (typeof characterOrId === 'object' && characterOrId?.entityType === 'npc') {
    return null;
  }
  return `/characters/${id}/theme`;
}

export function getCharacterViewPath(character) {
  return getCharacterProfilePath(character) || getCharacterSheetPath(character);
}

export function getCharactersCatalogPath() {
  return '/personnages';
}
